module.exports = __webpack_public_path__ + "img/171890-10.f3cc3c94.png";